module.exports = __webpack_public_path__ + "static/media/1008089.43b140f3.png";